module.exports = __webpack_public_path__ + "static/img/controldeacceso-1.ed45663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/controldeacceso-1.png
// module id = chcV
// module chunks = 1